import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import GlobalContext from "../../framework/GlobalContext";
import { focusCell } from "../../utils/gridUtils";
import { isEmpty } from "../../utils/utils";
const ReportContext = createContext();

export const ReportContextProvider = ({ children }) => {
  const reportGridRef = useRef();
  const { currentComponent, setCurrentComponent, showSpotlight } =
    useContext(GlobalContext);
  const { currentFocus } = useSelector((state) => {
    return state.commonReducer.tabs[state.commonReducer?.activeTabIndex];
  });
  const [showColumnDrawer, setShowColumnDrawer] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const focusGrid = useCallback(
    (api) => {
      if (!api) return;
      if (isEmpty(currentFocus)) {
        setTimeout(() => focusCell(api, 0), 300);
      } else {
        setTimeout(() => focusCell(api, currentFocus.rowIndex), 300);
      }
    },
    [currentFocus]
  );
  const listener = useCallback((event) => {
    const key = event?.key?.toLowerCase();
    const alt = event?.altKey;
    if (alt) {
      if (key === "o") {
        setShowColumnDrawer((prev) => !prev);
        return;
      }
      if (key === "f") {
        setShowFilterDrawer((prev) => !prev);
        return;
      }
    }
    if (key === "escape") {
      setShowColumnDrawer(false);
      setShowFilterDrawer(false);
      return;
    }
  }, []);
  useEffect(() => {
    if (!showSpotlight) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [listener, showSpotlight]);

  useEffect(() => {
    if (!currentComponent || currentComponent === "default_focus") {
      setCurrentComponent("grid_reports");
    }
  }, [currentComponent, setCurrentComponent]);
  return (
    <ReportContext.Provider
      value={{
        showColumnDrawer,
        setShowColumnDrawer,
        showFilterDrawer,
        setShowFilterDrawer,
        reportGridRef,
        focusGrid,
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};

export default ReportContext;
